import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/transportList/taskPage',
    method: 'post',
    data,
  })
}
export async function approval(data) {
  return request({
    url: '/transportList/check',
    method: 'post',
    data
  })
}
export async function revoke(data) {
  return request({
    url: '/transportList/revoke',
    method: 'post',
    data,
  })
}